﻿export class CloseRequested {
    static eventName() { return 'CloseRequested'; }

    eventName = CloseRequested.eventName;
}
